module.exports = __webpack_public_path__ + "media/project_quote/arrow-double-down-d47e0449.svg";